import React from 'react';
import PropTypes from 'prop-types';
import utilService from '../../../../services/UtilService';

import styles from './textEntry.scss';

const INPUT_FIELD_WIDTH_MULTIPLIER = 9;

class TextEntryPrint extends React.PureComponent {
    static propTypes = {
        defaultValue: PropTypes.string,
        handleInteractionReady: PropTypes.func.isRequired,
        size: PropTypes.number.isRequired,
    };

    componentDidMount() {
        this.props.handleInteractionReady(true);
    }

    render() {
        const size = utilService.getIntOr(this.props.size, 20);
        const style = { minWidth: size * INPUT_FIELD_WIDTH_MULTIPLIER };
        return (
            <span className={styles.print} style={style}>
                {this.props.defaultValue}
            </span>
        );
    }
}

export default TextEntryPrint;
